import { SET_DEVICE_FILTERS, SET_FLEET_FILTERS, SET_USER_FILTERS, SET_DRIVER_FILTERS, SET_ORGANIZATION_FILTERS } from './mutations'

export default {
    async setDeviceFilters ({ commit }, payload) {
        commit(SET_DEVICE_FILTERS, payload)
    },
    async setFleetFilters ({ commit }, payload) {
        commit(SET_FLEET_FILTERS, payload)
    },
    async setUserFilters ({ commit }, payload) {
        commit(SET_USER_FILTERS, payload)
    },
    async setDriverFilters ({ commit }, payload) {
        commit(SET_DRIVER_FILTERS, payload)
    },
    async setOrganizationFilters ({ commit }, payload) {
        commit(SET_ORGANIZATION_FILTERS, payload)
    }
}
